import gql from "graphql-tag";
import {
  AllHubFragment,
  JobInfoFragment,
  OrderInfoFragment,
  ParcelExportFragment,
  ParcelInfoFragment,
  ReceiverInfoFragment,
  SimpleOrderInfoFragment,
  TaskHistoryFragment,
} from "./fragments";

export const JobById = gql`
  query jobById($id: ID!) {
    jobById(id: $id) {
      job_orders {
        order_parcels {
          ...ParcelInfo
        }
      }
    }
  }

  ${ParcelInfoFragment}
`;

export const ParcelsByStatus = gql`
  query allParcelsByClient($params: ParcelsByClientFetchParams!, $queries: ParcelsByClientFetchQueries) {
    allParcelsByClient(params: $params, queries: $queries) {
      code
      message
      error
      data {
        ...ParcelInfo
      }
      countTotal
      totalPages
      currentPage
    }
  }
  ${ParcelInfoFragment}
`;
export const OrdersByStatus = gql`
  query allOrdersByClient($params: OrdersByClientFetchParams!, $queries: OrdersByClientFetchQueries) {
    allOrdersByClient(params: $params, queries: $queries) {
      code
      message
      error
      data {
        ...SimpleOrderInfo
      }
      countTotal
      totalPages
      currentPage
    }
  }
  ${SimpleOrderInfoFragment}
`;

export const OrderById = gql`
  query orderById($params: OneOrderFetchParams) {
    orderById(params: $params) {
      code
      message
      error
      data {
        ...OrderInfo
      }
    }
  }
  ${OrderInfoFragment}
`;

export const ParcelById = gql`
  query parcelById($id: ID) {
    parcelById(id: $id) {
      ...InfoParcel
      parcel_order {
        ...OrderInfo
      }
    }
  }
  ${ParcelInfoFragment}
  ${OrderInfoFragment}
`;

export const CountParcelsByStatus = gql`
  query countParcelsByStatusAndClientID($clientID: ID!, $status: [ParcelStatus]!) {
    countParcelsByStatusAndClientID(clientID: $clientID, status: $status) {
      count
    }
  }
`;
export const CountOrdersByStatus = gql`
  query countOrdersByStatusAndClientID($clientID: ID!, $status: [OrderStatus]!) {
    countOrdersByStatusAndClientID(clientID: $clientID, status: $status) {
      count
    }
  }
`;

export const ReceiverByClientID = gql`
  query allReceiversByClient($params: ReceiversByClientFetchParams!, $queries: ReceiversByClientFetchQueries) {
    allReceiversByClient(params: $params, queries: $queries) {
      code
      error
      message
      data {
        ...ReceiverInfo
      }
      countTotal
      totalPages
      currentPage
    }
  }
  ${ReceiverInfoFragment}
`;

export const JobsByClientId = gql`
  query allJobsByClient($params: JobsByClientFetchParams!, $queries: JobsByClientFetchQueries) {
    allJobsByClient(params: $params, queries: $queries) {
      code
      error
      message
      data {
        ...JobInfo
      }
      countTotal
      totalPages
      currentPage
    }
  }
  ${JobInfoFragment}
`;

export const RecapParcels = gql`
  query recapParcels($params: RecapParcelsFetchParams!, $queries: RecapParcelsFetchQueries) {
    recapParcels(params: $params, queries: $queries) {
      code
      message
      error
      data {
        successful {
          amount
          count
        }
        inprogress {
          amount
          count
        }
        cancelled {
          amount
          count
        }
      }
    }
  }
`;

export const GET_TASK_HISTORY = gql`
  query taskToExportClient($queries: TaskToExportClientInput!) {
    taskToExportClient(queries: $queries) {
      error
      message
      code
      data {
        tasksCount
        tasks {
          ...TaskHistoryFragment
        }
      }
    }
  }
  ${TaskHistoryFragment}
`;

export const GET_PARCELS_EXPORT = gql`
  query parcelsExport($filter: ParcelExportFilter!) {
    parcelsExport(filter: $filter) {
      error
      message
      code
      data {
        parcelsCount
        parcels {
          ...ParcelExportFragment
        }
      }
    }
  }
  ${ParcelExportFragment}
`;

export const ALL_HUBS = gql`
  query allHubs($queries: HubsFetchQueries) {
    allHubs(queries: $queries) {
      error
      code
      message
      data {
        _id
        name
        code
        location {
          city
          region
        }
      }
    }
  }
`;

export const GET_HUBS_BY_CITY = gql`
  query getAllHubsByCity($queries: HubFetchQueries) {
    getAllHubsByCity(queries: $queries) {
      message
      code
      data {
        ...AllHubFragment
      }
    }
  }
  ${AllHubFragment}
`;
